import axios from '../axiosConfig'; // Assuming this is your configured Axios instance

import { API_BASE_URL } from '../config';
const BASE_URL = API_BASE_URL+'/message';


export const fetchDirectContacts = async () => {
    var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  
    if (!axios.defaults.headers.common["Authorization"]) {
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }
    const response = await axios.get(`${BASE_URL}/contacts`, { headers });
    return response.data;
};

export const fetchChannels = async () => {
    var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  
    if (!axios.defaults.headers.common["Authorization"]) {
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }
    const response = await axios.get(`${BASE_URL}/channels`, { headers });
    return response.data;
};

export const fetchMessages = async (roomId) => {
    var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  
    if (!axios.defaults.headers.common["Authorization"]) {
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }
    const response = await axios.get(`${BASE_URL}/messages/${roomId}`, { headers });
    return response.data;
};

export const createMessage = async (message) => {
    var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
   var roomId = message.room;
    if (!axios.defaults.headers.common["Authorization"]) {
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }
    const response = await axios.get(`${BASE_URL}/messages/${roomId}`, message, { headers });
    return response.data;
};

export const removeMessage = async (messageId) => {
    var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  
    if (!axios.defaults.headers.common["Authorization"]) {
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }
    const response = await axios.post(`${BASE_URL}/delete_message/${messageId}`, { headers });
    return response.data;
};

export const fetchEmployeeContacts = async () => {
    var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  
    if (!axios.defaults.headers.common["Authorization"]) {
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }
    const response = await axios.get('/message/employee-contacts', {headers});
    console.log(response);
    return response.data;
};

export const fenchConversations = async () => {
  var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

  if (!axios.defaults.headers.common["Authorization"]) {
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }
  const response = await axios.get('/message/active/conversations', {headers});
  console.log(response);
  return response;
};

export const fenchNotifications = async () => {
  var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  if (!axios.defaults.headers.common["Authorization"]) {
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }
  const response = await axios.get('/activity/notifications', {headers});
  console.log(response);
  return response;
}

export const fetchActivities = async () => {
  var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  if (!axios.defaults.headers.common["Authorization"]) {
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }
  const response = await axios.get('/activity/logs', {headers});
  console.log(response);
  return response;
}

export const submitApproval = async (data) => {
  
  var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  if (!axios.defaults.headers.common["Authorization"]) {
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }
  const response = await axios.post('/activity/approve', data, {headers});
  console.log(response);
  return response;
  
  
}